import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { PrivatePagesLayout } from '@old/ui/private-layout/private-layout';

export type PrivateLayoutProps = PropsWithChildren<{
  legacy?: boolean;
  withHeader?: boolean;
  withFooter?: boolean;
  withSideSpaces?: boolean;
  fillAvailableSpace?: boolean;
  footerConfig?: { withMarginTop: boolean };
}>;

export const priv = ({
  children,
  legacy,
  withHeader,
  withFooter,
  withSideSpaces,
  fillAvailableSpace = false,
  footerConfig,
}: PrivateLayoutProps) => {
  if (legacy) {
    return (
      <PrivatePagesLayout
        withHeader={withHeader}
        withFooter={withFooter}
        withSideSpaces={withSideSpaces}
        backgroundWhite
        fillAvailableSpace={fillAvailableSpace}
        footerConfig={footerConfig}
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: fillAvailableSpace ? '100%' : 'auto',
        minHeight: '100%',
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid #e0e0e0',
          padding: 2,
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          flex: '0 0 auto',
        }}
      >
        <Box sx={{ maxWidth: 1200, margin: '0 auto' }}>Header / Navigation</Box>
      </Box>

      <Box
        sx={{
          flex: fillAvailableSpace ? '1 1 0' : '1 0 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          padding: 3,
          maxWidth: 1200,
          margin: '0 auto',
          width: '100%',
        }}
      >
        {children}
      </Box>

      <Box
        sx={{
          backgroundColor: 'white',
          borderTop: '1px solid #e0e0e0',
          padding: 2,
          textAlign: 'center',
          fontSize: 12,
          color: 'textSecondary',
          flex: '0 0 auto',
        }}
      >
        © 2026 SiloReal
      </Box>
    </Box>
  );
};
